/* Cola do buybox copiado (Debutify dele) com a NOSSA loja.
   - seletor de variantes dele (cl-variant-selects: radios/selects) -> variante NOSSA pelas opcoes
     (mesmos nomes/valores aqui), grava no input id do form UNICO (buy_buttons nativo ou o form oculto
     da secao da home), atualiza legenda "Color: X", disponibilidade do ATC e ?variant= na URL;
   - publica a variante DELE (JSON copiado, mesmos media ids da galeria copiada) no pubsub do tema
     (window.clPub) -> main-product-gallery.js leva a galeria para a foto da variante.
   O envio do form (ATC) e tratado pelo cl-cart.js (adiciona e abre a gaveta). */
(function () {
  'use strict';
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function parse(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

  function Pdp(root) {
    this.root = root;
    this.p = parse(root.querySelector('script[data-cl-product]'));
    this.form = document.getElementById(root.getAttribute('data-form-id'));
    this.vs = root.querySelector('cl-variant-selects');
    this.comp = this.vs ? (parse(this.vs.querySelector('script[data-product-variants]')) || []) : [];
    if (!this.p || !this.vs) return;
    var self = this;
    this.vs.addEventListener('change', function () { self.update(true); });
    var q = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    if (q && !root.hasAttribute('data-no-url')) {
      var v = this.p.variants.find(function (x) { return String(x.id) === q; });
      if (v) this.select(v.options);
    }
    this.update(false);
  }

  Pdp.prototype.fieldsets = function () {
    return $$(this.vs, 'fieldset, .product-form__input, [class*="product-form__input"]').filter(function (fs, i, a) {
      return a.indexOf(fs.parentElement && fs.parentElement.closest('fieldset')) < 0;
    });
  };

  Pdp.prototype.options = function () {
    return this.fieldsets().map(function (fs) {
      var r = fs.querySelector('input[type="radio"]:checked');
      if (r) return r.value;
      var s = fs.querySelector('select');
      return s ? s.value : null;
    }).filter(function (x) { return x != null; });
  };

  Pdp.prototype.select = function (opts) {
    this.fieldsets().forEach(function (fs, i) {
      if (opts[i] == null) return;
      var r = $$(fs, 'input[type="radio"]').find(function (x) { return x.value === opts[i]; });
      if (r) r.checked = true;
      var s = fs.querySelector('select'); if (s) s.value = opts[i];
    });
  };

  Pdp.prototype.update = function (user) {
    var o = this.options();
    var v = this.p.variants.find(function (x) { return o.every(function (val, i) { return x.options[i] === val; }); });
    if (!v) return;
    this.v = v;
    if (this.form) {
      var inp = this.form.querySelector('input[name="id"]');
      if (inp && inp.value !== String(v.id)) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    this.fieldsets().forEach(function (fs, i) {
      var s = fs.querySelector('[data-selected-value]'); if (s && o[i] != null) s.textContent = o[i];
    });
    $$(this.root, '[data-cl-atc]').forEach(function (b) { b.disabled = !v.available; });
    if (user) {
      var cv = this.comp.find(function (c) { return o.every(function (val, i) { return c.options[i] === val; }); });
      if (cv && window.clPub) {
        try { window.clPub.publish(window.clPub.EV.variantChange, { data: { variant: cv, sectionId: '', html: null } }); } catch (e) {}
      }
      if (!this.root.hasAttribute('data-no-url') && window.history.replaceState) {
        history.replaceState({}, '', location.pathname + '?variant=' + v.id);
      }
    }
    this.root.dispatchEvent(new CustomEvent('cl:variant', { bubbles: true, detail: { variant: v, product: this.p } }));
  };

  // ---- app Kaching REAL no [data-cl-app-slot] (no lugar da replica) ----
  // - deal do operador com hideVariantPicker: o seletor copiado some (o app faz a escolha);
  // - o app trocou o id do form unico (barra/variante do item 1): seletor copiado e galeria acompanham.
  function deals(slot) {
    var out = [];
    $$(slot, 'script.kaching-bundles-deal-block-settings, script[class*="deal-block"]').forEach(function (s) {
      var d = parse(s); if (d) out = out.concat(Array.isArray(d) ? d : [d]);
    });
    return out;
  }
  function app(root) {
    var slot = root.querySelector('[data-cl-app-slot]'), pdp = root.__clPdp;
    if (!slot || root.__clApp) return;
    root.__clApp = true;
    var tries = 0;
    (function mark() {
      var k = slot.querySelector('kaching-bundle'), ds = deals(slot);
      var hide = ds.some(function (d) { return d && d.hideVariantPicker; }) && !!(k && k.querySelector('.kaching-bundles__bar'));
      var vs = root.querySelector('cl-variant-selects');
      var host = vs && (vs.closest('.shopify-block') || vs);
      if (host) host.classList.toggle('kaching-bundles--variant-selects-hidden', hide);
      if (++tries < 40 && !(k && k.dataset.initialized)) setTimeout(mark, 250);
    })();
    if (!pdp || !pdp.form) return;
    var inp = pdp.form.querySelector('input[name="id"]');
    if (!inp) return;
    function fromForm() {
      if (!pdp.v || String(pdp.v.id) === String(inp.value)) return;
      var v = pdp.p.variants.find(function (x) { return String(x.id) === String(inp.value); });
      if (!v) return;
      pdp.select(v.options); pdp.update(true);
    }
    inp.addEventListener('change', fromForm);
    if (window.MutationObserver) new MutationObserver(fromForm).observe(inp, { attributes: true, attributeFilter: ['value'] });
    slot.addEventListener('change', function () { setTimeout(fromForm, 50); setTimeout(fromForm, 600); });
    slot.addEventListener('click', function () { setTimeout(fromForm, 100); setTimeout(fromForm, 700); });
  }

  function boot() {
    $$(document, '.cl-pdp').forEach(function (r) { if (!r.__clPdp) r.__clPdp = new Pdp(r); app(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.ClPdp = Pdp;
})();
